import React, { useState } from "react";
import HtmlParser from "../../components/html-parser";
import CommonAnalyticsEvent from "../../services/analytics/main/common";

type HelpAccordion = {
  defaultOpen?: any;
  accordionHeading: string;
  tile: { longTitle: string; en_longTitle?: string; answer: string };
};

const HelpAccordion = ({
  defaultOpen,
  accordionHeading,
  tile
}: HelpAccordion) => {
  const [defaultContent, setDefaultContent] = useState(!!defaultOpen);

  const toggleContent = () => {
    CommonAnalyticsEvent.accordion({
      category: accordionHeading,
      item: tile,
      isActive: !defaultContent
    });
    setDefaultContent(prevContent => !prevContent);
  };

  return (
    <div className="accordion">
      <div className="accordion_card_title" onClick={toggleContent}>
        <h4 className="accordion_heading">{tile.longTitle}</h4>
        <span
          className={`toggle-banner ${defaultContent ? "minus" : "plus"}`}
        />
      </div>
      {defaultContent && (
        <div className="accordion_content">
          <HtmlParser html={tile.answer} />
        </div>
      )}
    </div>
  );
};

export default HelpAccordion;
